const validateRequired = value => (value ? null : "Required");

const checkRequiredForDependant = (values, errors, dependant, field) => {
  if (!values[`${dependant}${field}`]) {
    errors[`${dependant}${field}`] = "Required";
  }
};

const validateRequiredForDependant = (values, errors, dependant) => {
  if (values[`${dependant}Name`]) {
    checkRequiredForDependant(values, errors, dependant, 'Occupation');
    checkRequiredForDependant(values, errors, dependant, 'JobTitle');
    checkRequiredForDependant(values, errors, dependant, 'Race');
    checkRequiredForDependant(values, errors, dependant, 'Nationality');
    checkRequiredForDependant(values, errors, dependant, 'CountryOfResidence');
    checkRequiredForDependant(values, errors, dependant, 'Height');
    checkRequiredForDependant(values, errors, dependant, 'Weight');
  }
};

const checkRequiredForHabits = (values, errors, member, field, detail) => {
  if (values[`${member}${field}`] === "Yes" && !values[detail]) {
    errors[detail] = "Required";
  }
};

const validateRequiredForHabits = (values, errors, member) => {
  checkRequiredForHabits(values, errors, member, 'Smoke', `${member}SmokeQuantity`);
  checkRequiredForHabits(values, errors, member, 'Smoke', `${member}SmokeNoOfYears`);
  checkRequiredForHabits(values, errors, member, 'ConsumeAlcohol', `${member}AlcoholType`);
  checkRequiredForHabits(values, errors, member, 'ConsumeAlcohol', `${member}AlcoholQuantity`);
  checkRequiredForHabits(values, errors, member, 'ConsumeAlcohol', `${member}AlcoholFrequencyPerWeek`);
  checkRequiredForHabits(values, errors, member, 'ActivityTest', 'ActivityDetails');
  checkRequiredForHabits(values, errors, member, 'DoctorRecommendationTest', 'DoctorRecommendationDetails');
  checkRequiredForHabits(values, errors, member, 'ConsultationTest', 'DiagnosisConsultationDetails');
  checkRequiredForHabits(values, errors, member, 'AbnormalTest', 'LastConsultationDetails');
  checkRequiredForHabits(values, errors, member, 'SpecialTerms', 'SpecialTermsDetails');
  checkRequiredForHabits(values, errors, member, 'HazardousActivity', 'HazardousActivityDetails');
};

const validateRequiredForFamilyHistory = (values, errors) => {
  if (values.EmpFamilyHistory === "Yes") {
    if (!values.FamilyRelationship1) {
      errors.FamilyRelationship1 = "Required";
    }
  }
};

const checkRequiredForForm = (values, errors, field, info) => {
  if (values[field] === "Yes" && !values[info]) {
    errors[info] = "Required";
  }
};


const validateForm = values => {
  const errors = {};

  ["Dep1", "Dep2", "Dep3", "Dep4"].forEach(dependant => {
    validateRequiredForDependant(values, errors, dependant);
    validateRequiredForHabits(values, errors, dependant);
  });

  validateRequiredForHabits(values, errors, "Emp");
  validateRequiredForFamilyHistory(values, errors);

  checkRequiredForForm(values, errors, 'EmpRegularDoc', 'EmpRegularDocInfo');
  checkRequiredForForm(values, errors, 'EmpDiagnosis', 'EmpDiagnosisInfo');
  checkRequiredForForm(values, errors, 'EmpMedTreatment', 'EmpMedTreatmentInfo');
  checkRequiredForForm(values, errors, 'EmpHighRiskSexLife', 'EmpHighRiskSexLifeInfo');
  checkRequiredForForm(values, errors, 'EmpExclusions', 'EmpExclusionsInfo');
  checkRequiredForForm(values, errors, 'EmpAdventure', 'EmpAdventureInfo');

  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/validation.js